import React from 'react';
import ARTracker from '../../classes/ARTracker';
import { TrackerTypes } from '../../globals';
import { IconFillStyles, TrackerImageIcon, TrackerObjectIcon, TrackerSurfaceIcon } from '../Iconset';

export default function PlacementModeComponent(props: {
	trackerList: Array<ARTracker>,
	currentType?: TrackerTypes,
	onTrackerTypeSwitch: (type: TrackerTypes) => void,
})
{
	const placementOptions = [
		{
			type: TrackerTypes.MODEL,
			label: "Object",
			icon: <TrackerObjectIcon />,
		},
		{
			type: TrackerTypes.IMAGE,
			label: "Image",
			icon: <TrackerImageIcon />,
		},
		{
			type: TrackerTypes.SLAM,
			label: "Surface",
			icon: <TrackerSurfaceIcon />,
		}
	];

	const hasTargetsOfType = (type: TrackerTypes) =>
	{
		if(!props.trackerList) return false;

		for(const tracker of props.trackerList)
		{
			if(tracker.trackerType === type) return true;
		}
		
		return false;
	};

	return (
		<div className={'placementOptionsContainer'}>
			{
				placementOptions.filter(option => hasTargetsOfType(option.type)).map((option, idx) =>
				{
					const selected = props.currentType === option.type;

					return (
						<div key={idx}
							data-name={"placement-mode-option-" + option.type}
							className={"placementModeOption"}
							onClick={() => props.onTrackerTypeSwitch(option.type)}
						>
							<div
								className={'placementModeButton'}
								data-status={selected ? 'selected' : ''}
							>
								{ React.cloneElement(option.icon, { fillStyle: selected ? IconFillStyles.dark : IconFillStyles.default }) }
							</div>
							{option.label}
						</div>
					);
				})
			}
		</div>
	);
}